<template>
  <div class="CONTENT" >
    <div class="tile is-parent">
      <article class="tile is-child box">
        <h1 class="title">Project</h1>
        <div class="columns">
          <div class="column">
            <span class="button is-primary" @click="createNewProject">NEW</span>
            <span class="button is-primary" @click="loadStateFile">
              <span class="icon is-small">
                <i class="fa fa-arrow-circle-down" aria-hidden="true"></i>
              </span>&nbsp;
              LOAD FROM FILE
            </span>
            <input type="file" ref="fileselector" v-show="false" @change="onFileSelected" >
            <span class="button is-primary" @click="saveStateFile">
              <span class="icon is-small">
                <i class="fa fa-arrow-circle-up" aria-hidden="true"></i>
              </span>&nbsp;
              SAVE TO FILE
            </span>
          </div>
        </div>
      </article>
    </div>
    <div class="tile is-parent">
      <article class="tile is-child box">
        <div class="columns">
          <div class="column is-3">
            <p class="title">Project Name</p><br/>
            <table class="">
              <tr >
                <td width="80px">Name</td>
                <td>
                  <p v-if="active_input !== 'projectname'">
                    {{projectName}}
                    <span @click="active_input = 'projectname'" v-if="projectName === ''" class="tag is-danger">NO PROJECT NAME</span>
                  </p>
                  <p class="control" v-if="active_input === 'projectname'">
                    <input v-model="projectName" class="input is-small">
                  </p>
                </td>
                <td width="80px">
                  <span v-if="active_input !== 'projectname'" @click="active_input = 'projectname'" class="button is-primary is-small pull-right"> edit</span>
                  <span v-if="active_input === 'projectname'" @click="active_input = ''" class="button is-primary is-small pull-right"> Update</span>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </article>
    </div>
    <div class="tile is-parent">
      <article class="tile is-child box">
         Before uploading a file open it in gravit.io, press trim canvas, then export the image as SVG & use that SVG. This helps maximize compatibility with the HTML Engine.
         <br />
         <img :src="trim_instructions_image" width="200px" style="margin-top: 20px; margin-bottom: 20px" />

        <FileLoader></Fileloader>
        
      </article>
    </div>
    <notification v-if="uploadWarnings.length" :message="uploadWarnings[uploadWarnings.length-1]" type="warning" direction="'Up'" />
    <div class="tile is-parent">
      <article class="tile is-child box scrollx">
        <h2 class="title">Assets</h2>
        <div class="columns">
          <div class="column is-3" v-for="asset in assetList">
            <div class="panel">
              <p class="panel-heading">{{asset.unique_name}}</p>
              
              {{numnodes = 0 | hide}}

              <div class="panel-block">
                <table class="table" v-if="asset.nodes">
                  <tr v-for="nodelist, nodetype in assetNodes(asset)">
                    <td>{{nodetype}} nodes</td>
                    <td>{{nodelist.length}} {{ numnodes+=nodelist.length | hide }}</td>
                  </tr>
                  <tr >
                    <td>All nodes</td>
                    <td>{{numnodes}}</td>
                  </tr>
                </table>
              </div>
              <div class="footerAsset">
                <span class="button is-danger" @click="removeAsset(asset)">
                  <span class="icon is-small">
                    <i class="fa fa-times-circle" aria-hidden="true"></i>
                  </span>&nbsp;
                  REMOVE
                </span>
              </div>
            </div>
          </div>
        </div>
        
        <div v-if="Object.keys(assetList).length <= 0" style="height:40px;">
          <div class="tag is-danger">
            No svg files have been loaded
          </div>
        </div>
      </article>
    </div>

  </div>
</template>

<script>
import FileLoader from "./../components/fileloader";
import { mapGetters, mapActions } from "vuex";
import FileSaver from "file-saver";
import Notification from 'vue-bulma-notification'

export default {
  components: {
    FileLoader,
    Notification
  },

  data() {
    return {
      active_input: ""
    };
  },

  computed: {
    ...mapGetters({
      assetList: "assetList",
          uploadWarnings: "uploadWarnings"

    }),
    projectName: {
      get: function() {
        return this.$store.state.project.project_name;
      },
      set: function(new_project_name) {
        this.updateProjectName(new_project_name);
      }
    },
    trim_instructions_image: function () {
      return require('../assets/trim_instructions.png')
    }
  },

  methods: {
    ...mapActions([
      "toggleSidebar",
      "createNewProject",
      "saveState",
      "loadState",
      "loadProjectFile",
      "updateProjectName"
    ]),

    loadStateFile: function() {
      this.$refs.fileselector.click();
    },

    onFileSelected: function(e) {
      this.loadProjectFile(e.target.files[0]);
      e.preventDefault();
    },

    saveStateFile: function() {
      const {operation_list, upload_files_pending, upload_warnings, redooperation_list, lastNodeIdAdded, local_save_working, valid_file_types, ...saveStuff} = this.$store.state.project

      var blob = new window.Blob([JSON.stringify(saveStuff)], {
        type: "text/plain;charset=utf-8"
      });
      FileSaver.saveAs(
        blob,
        "project-" + this.$store.state.project.project_name + ".json"
      );
    },

    assetNodes: function(asset) {
      var nodes = {};
      var node;
      for (var nodekey in asset.nodes) {
        node = asset.nodes[nodekey];
        if (nodes[node.type] === undefined) {
          nodes[node.type] = [];
        }
        nodes[node.type].push(node);
      }
      return nodes;
    },
    removeAsset: function(asset) {
      const { id } = asset;
      delete this.assetList[id];
      this.$forceUpdate();
      this.saveState();
    }
  },
  mounted: function() {
    // console.log(this.assetList)
  },

  filters: {
    hide: function(value) {
      return "";
    }
  }
};
</script>

<style lang="scss" scoped>
.footerAsset {
  margin: auto;
  display: grid;
}
.button.is-danger {
  border-radius: 0px;
}
.scrollx {
  width: 100%;
  overflow-x: scroll;
}
</style>



// WEBPACK FOOTER //
// index.vue?342ff5c4